import { Component, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Transaction } from '../transaction-store/transaction';
import { Router } from '@angular/router';
import { AppSettings } from '../app.settings';
import { UserModel } from '../user/login.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CorporateMatching } from '../transaction-store/corporate-matching';
import { DesignationStateModel } from '../transaction-store/designation';
import { DonateAPIService } from '../api/donate.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegisterModalComponent } from './register-modal.component';
import { GaClient } from '../../init';
import { Donation } from 'app/transaction-store/donation';
import { Frequency, Recurring } from 'app/transaction-store/recurring';
import { BillingInfo } from 'app/transaction-store/billing-info';
import { TributeInfo } from 'app/transaction-store/tribute-info';

@Component({
  selector: 'app-thank-you',
  template: `
    <section class="container">
      <div class="row">
        <div class="col-12 donation-complete">
          <div class="row">
            <div class="col-12 text-center pb-3">
              <div>
                <h1>{{ headline }}</h1>
                <div class="row">
                  <div class="col-12">
                    <p class="subheading">
                      <span [innerHtml]="subline"></span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="donation-details">
            <h1 class="primary-color text-center">
              {{
                transaction.total_value | currency: currencyCode:'symbol-narrow'
              }}
            </h1>
            <table class="md-table">
              <tr>
                <td>Date:</td>
                <td>{{ transaction.created | date }}</td>
              </tr>
              <tr *ngIf="transaction.tracking_id">
                <td>Tracking:</td>
                <td>{{ transaction.tracking_id }}</td>
              </tr>
              <tr *ngIf="campaign && campaign.title">
                <td>Campaign:</td>
                <td>{{ campaign.title }}</td>
              </tr>
            </table>

            <div
              *ngIf="
                transaction.schedule ||
                transaction.designation ||
                transaction.designations ||
                showCustomNotes
              "
            >
              <hr />
              <table class="sm-table">
                <tr
                  *ngIf="
                    transaction.designation && transaction.designation.title
                  "
                >
                  <td>Gift Designation:</td>
                  <td>{{ transaction.designation.title }}</td>
                </tr>
                <tr *ngIf="transaction.designations">
                  <td>Gift Designations:</td>
                  <td *ngFor="let item of transaction.designations">
                    {{ item.title }}
                  </td>
                </tr>
                <tr *ngIf="transaction.form_data.designation_note">
                  <td>Note:</td>
                  <td>{{ transaction.form_data.designation_note }}</td>
                </tr>
                <tr
                  *ngIf="transaction.form_data.custom_note_1 && showCustomNotes"
                >
                  <td>{{ transaction.notes.note1[0] }}</td>
                  <td>{{ transaction.notes.note1[1] }}</td>
                </tr>
                <tr
                  *ngIf="transaction.form_data.custom_note_2 && showCustomNotes"
                >
                  <td>{{ transaction.notes.note2[0] }}</td>
                  <td>{{ transaction.notes.note2[1] }}</td>
                </tr>
                <tr
                  *ngIf="transaction.form_data.custom_note_3 && showCustomNotes"
                >
                  <td>{{ transaction.notes.note3[0] }}</td>
                  <td>{{ transaction.notes.note3[1] }}</td>
                </tr>
                <tr
                  *ngIf="transaction.form_data.custom_note_4 && showCustomNotes"
                >
                  <td>{{ transaction.notes.note4[0] }}</td>
                  <td>{{ transaction.notes.note4[1] }}</td>
                </tr>
                <tr
                  *ngIf="transaction.form_data.custom_note_5 && showCustomNotes"
                >
                  <td>{{ transaction.notes.note5[0] }}</td>
                  <td>{{ transaction.notes.note5[1] }}</td>
                </tr>
                <tr *ngIf="transaction.schedule?.start_date">
                  <td>Start Date:</td>
                  <td>
                    {{
                      removeTime(
                        transaction.schedule.start_date,
                        transaction.schedule.schedule_type
                      ) | date
                    }}
                  </td>
                </tr>
                <tr *ngIf="transaction.schedule?.final_date">
                  <td>Last Payment Date:</td>
                  <td>
                    {{
                      removeTime(
                        transaction.schedule.final_date,
                        transaction.schedule.schedule_type
                      ) | date
                    }}
                  </td>
                </tr>
                <tr *ngIf="transaction.schedule?.schedule_type">
                  <td>Frequency:</td>
                  <td>
                    {{ getFrequencyText(transaction.schedule.schedule_type) }}
                  </td>
                </tr>
              </table>
            </div>
            <div
              *ngIf="
                transaction.form_data &&
                (transaction.form_data.tribute_first_name ||
                  transaction.form_data.tribute_last_name)
              "
            >
              <hr />
              <p>Tribute</p>
              <table class="sm-table">
                <tr
                  *ngIf="
                    transaction.form_data.tribute_first_name ||
                    transaction.form_data.tribute_last_name
                  "
                >
                  <td>Tribute Name:</td>
                  <td>
                    {{ transaction.form_data.tribute_first_name }}
                    {{ transaction.form_data.tribute_last_name }}
                  </td>
                </tr>
                <tr *ngIf="transaction.form_data.tribute_email">
                  <td>Tribute Email:</td>
                  <td>{{ transaction.form_data.tribute_email }}</td>
                </tr>
                <tr *ngIf="transaction.form_data.tribute_address1">
                  <td>Tribute Address:</td>
                  <td>
                    {{ transaction.form_data.tribute_address1 }}
                    {{ transaction.form_data.tribute_address2 }} <br />
                    {{ transaction.form_data.tribute_city }},
                    {{ transaction.form_data.tribute_state }}
                    {{ transaction.form_data.tribute_postal_code }}
                    {{ transaction.form_data.tribute_country }}
                  </td>
                </tr>
              </table>

              <p *ngIf="transaction.form_data.honorees">Tribute Honorees</p>
              <table *ngIf="transaction.form_data.honorees" class="sm-table">
                <tr *ngFor="let honoree of transaction.form_data.honorees">
                  <td>{{ honoree.firstname }} {{ honoree.lastname }}:</td>
                  <td>{{ honoree.message }}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="row impact-match">
            <div *ngIf="designationDisplay" class="col">
              <div class="container text-center">
                <div class="row">
                  <div class="col pb-2">
                    <h3>Designate Your Gift</h3>
                    <p>
                      Choose how your donation will be used & make your gift in
                      honor of someone.
                    </p>
                  </div>
                </div>
              </div>
              <div class="container text-center">
                <div class="row">
                  <div class="col">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      (click)="openModal(desContent)"
                      aria-label="Designate now"
                    >
                      Designate Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="corporateDisplay" class="col">
              <div class="container text-center">
                <div class="row">
                  <div class="col pb-2">
                    <h3>Multiply with Corporate Matching</h3>
                    <p>
                      Choose from the following corporations who have agreed to
                      match your gift.
                    </p>
                  </div>
                </div>
              </div>
              <div class="container text-center">
                <div class="row">
                  <div class="col">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      (click)="openModal(corporateContent)"
                      aria-label="Find your employer"
                    >
                      Find your employer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="impactDisplay">
            <div class="col-12">
              <hr />
            </div>
          </div>

          <router-outlet name="impact"></router-outlet>

          <div
            class="registration-details text-center"
            *ngIf="registration == 'start'"
          >
            <h2>Create your account!</h2>
            <p>
              Make it faster to access your donations online anytime. Creating
              an account will help you keep track of your previous donations and
              simplify your future giving. It only takes a minute. No additional
              information will be required.
            </p>
            <button
              class="btn btn-lg primary-color-background"
              type="button"
              (click)="register()"
              aria-label="Get started"
            >
              Get Started
            </button>
            <div class="registration-background"></div>
          </div>

          <div
            class="registration-details text-center"
            *ngIf="registration == 'done'"
          >
            <h2>Thank You for Registering!</h2>
            <p>
              Sign in at any time to review donations, update your information
              and change your giving preferences.
            </p>
            <button
              class="btn btn-lg primary-color-background"
              type="button"
              (click)="viewDonations()"
              aria-label="View donations"
            >
              View Donations
            </button>
            <div class="registration-background"></div>
          </div>

          <div class="row" *ngIf="share.display">
            <div class="col-12">
              <hr />
            </div>
            <div class="text-center col-12">
              <p>Share and inspire your friends.</p>
              <div class="link-separator">
                <a
                  class="primary-color"
                  tabindex="1"
                  (click)="openPopUp()"
                  target="_blank"
                  aria-label="share on facebook"
                  >Facebook</a
                >
                <a
                  class="primary-color"
                  tabindex="1"
                  (click)="loadTwitter()"
                  target="_blank"
                  aria-label="share on twitter"
                  >Twitter</a
                >
                <a
                  class="primary-color"
                  [href]="share.email"
                  target="_blank"
                  aria-label="share by email"
                  >Email</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <router-outlet name="footer"></router-outlet>

    <ng-template #desContent let-c="close" let-d="dismiss">
      <div class="modal-header d-block text-center container">
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="d('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h2 class="col-12">Choose Your Designation</h2>
        <p class="col-12">
          Choose how your donation will be used and make your gift in honor of
          someone.
        </p>
      </div>
      <div class="modal-body container">
        <router-outlet name="designations"></router-outlet>
        <div class="d-flex justify-content-center">
          <button
            type="submit"
            (click)="saveDesignation(c)"
            class="btn btn-primary"
            aria-label="save designation"
          >
            Save Designation
            <div
              *ngIf="designationLoading"
              class="idonate-spinner"
              alt="Loader"
            ></div>
          </button>
        </div>
      </div>
    </ng-template>
    <ng-template #corporateContent let-c="close" let-d="dismiss">
      <div class="modal-header d-block text-center container">
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="d('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h2 class="col-12">Multiply Your Gift with Corporate Matching</h2>
        <p class="col-12">
          Choose from the following corporations who have agreed to match your
          gift.
        </p>
      </div>
      <div class="modal-body container">
        <router-outlet name="corporate"></router-outlet>
        <div class="d-flex justify-content-center">
          <button
            type="submit"
            (click)="saveCorporateMatching(c)"
            class="btn btn-primary"
            aria-label="save corporate match"
          >
            Match and Give More
            <div
              *ngIf="corporateLoading"
              class="idonate-spinner"
              alt="Loader"
            ></div>
          </button>
        </div>
      </div>
    </ng-template>
  `
})
export class ThankYouComponent implements OnInit {
  @Select(state => state) state: Observable<any>;
  @Select() transaction$: Observable<Transaction>;
  @Select() user$: Observable<UserModel>;
  public transaction: any = {
    form_data: {}
  };
  campaign: any = {};
  designationDisplay = false;
  corporateDisplay = false;
  designationLoading = false;
  corporateLoading = false;
  impactDisplay = false;
  currencyCode = 'USD';
  share = {
    display: this.settings.getValue('properties').social_sharing
      ? this.settings.getValue('properties').social_sharing.mode
      : false,
    twitter: this.getTwitterVal(),
    facebook: this.getFacebookVal(),
    email: this.getEmailVal()
  };
  registration = '';
  headline = 'Thank you for your donation';
  subline: SafeHtml = '';
  showCustomNotes = false;
  sessionKey = '';
  designationEnabledOnPrimary = true;
  designationsLocked = false;
  dtdPublicKey = '';
  dtdPartnerKey = '';
  campaignId = '';

  @Select() corporateMatching$: Observable<CorporateMatching>;
  @Select() designations$: Observable<DesignationStateModel>;

  resolvedState: {
    donation: Donation;
    recurring: Recurring;
    corporateMatching: CorporateMatching;
    billingInfo: BillingInfo;
    tributeInfo: TributeInfo;
    transaction: Transaction;
  };

  constructor(
    private router: Router,
    private settings: AppSettings,
    private sanitizer: DomSanitizer,
    private donateAPI: DonateAPIService,
    private modalService: NgbModal
  ) {
    this.state.subscribe(newState => {
      this.resolvedState = newState;
    });

    const properties = this.settings.getValue('properties');
    const organization = this.settings.getValue('organization');
    this.currencyCode = organization.currency_code;
    this.dtdPublicKey = organization.details['doublethedonation.public_key'];
    this.dtdPartnerKey = organization.details['doublethedonation.partner_key'];
    this.designationsLocked = properties.designation_lock;
    this.designationEnabledOnPrimary = properties.components.some(
      (a: string) => a === 'designations'
    );

    this.campaignId = properties.campaign_id || (properties.campaign ? properties.campaign.id : undefined);
    if (properties.thank_you && properties.thank_you.components) {
      properties.thank_you.components.map(item => {
        if (item === 'designations') {
          this.designationDisplay = true;
        } else if (item === 'corporate_matching') {
          this.corporateDisplay = true;
        } else if (item === 'impact') {
          this.impactDisplay = true;
        }
      });
    }
    if (properties.thanks_custom_notes) {
      this.showCustomNotes = true;
    }
    if (properties.thanks_headline !== '') {
      this.headline = properties.thanks_headline;
    }
    if (properties.thanks_message) {
      this.subline = this.sanitizer.bypassSecurityTrustHtml(
        properties.thanks_message
      );
    }
    if (properties.enable_register) {
      this.user$.subscribe(item => {
        if (item && item.session_key && item.session_key !== '') {
          this.sessionKey = item.session_key;
          this.registration = 'done';
        } else {
          this.registration = 'start';
        }
      });
    }
    let desSub = null;
    this.transaction$.subscribe(item => {
      if (!item.tran.transaction && !item.tran.schedule) {
        this.router.navigate(['']);
        return;
      }
      this.transaction = item.tran.transaction || {};
      this.transaction.designation = item.tran.designation;
      this.transaction.schedule = item.tran.schedule;
      this.campaign = item.tran.campaign || {};
      this.transaction.form_data = item.tran.form_data;
      const form = item.tran.form_data;

      this.transaction.notes = {
        note1: form.custom_note_1
          ? [
              form.custom_note_1.split(' = ')[0],
              form.custom_note_1
                .split(' = ')
                .slice(1)
                .join(' = ')
            ]
          : null,
        note2: form.custom_note_2
          ? [
              form.custom_note_2.split(' = ')[0],
              form.custom_note_2
                .split(' = ')
                .slice(1)
                .join(' = ')
            ]
          : null,
        note3: form.custom_note_3
          ? [
              form.custom_note_3.split(' = ')[0],
              form.custom_note_3
                .split(' = ')
                .slice(1)
                .join(' = ')
            ]
          : null,
        note4: form.custom_note_4
          ? [
              form.custom_note_4.split(' = ')[0],
              form.custom_note_4
                .split(' = ')
                .slice(1)
                .join(' = ')
            ]
          : null,
        note5: form.custom_note_5
          ? [
              form.custom_note_5.split(' = ')[0],
              form.custom_note_5
                .split(' = ')
                .slice(1)
                .join(' = ')
            ]
          : null
      };
      if (item.tran.transaction) {
        this.transaction.tracking_id = item.tran.transaction.id.substring(0, 8);
      } else if (item.tran.schedule) {
        this.transaction.tracking_id = item.tran.schedule.id.substring(0, 8);
      }

      this.designationDisplay =
        this.designationDisplay && this.displayDesignationCriteria(item);

      if (
        item.tran.form_data &&
        item.tran.form_data.double_the_donation_company_id
      ) {
        this.corporateDisplay = false;
      }
      if (!properties.social_sharing || !properties.social_sharing.mode) {
        this.share.display = false;
      }
      if (desSub) {
        return;
      }
      desSub = this.designations$.subscribe(
        (desState: DesignationStateModel) => {
          if (desState.items && desState.items.length > 1) {
            this.transaction.designations = desState.items;
          }
        }
      );
    });
  }
  ngOnInit() {}

  requireCustomDesignation() {
    const embedProp = Boolean(
      Number(this.settings.getValue('properties').require_custom_designation)
    );
    const labelValue = this.settings.getValue('properties')
      .custom_designation_label;
    return embedProp && labelValue != null && labelValue.trim() != '';
  }

  displayDesignationCriteria(item) {
    // locked designation, don't display designation selection
    if (this.designationsLocked) {
      return false;
    }
    const designationInResponse =
      item.tran.form_data &&
      item.tran.form_data.designations &&
      item.tran.form_data.designations.length > 0;
    // designation was present on the primary page and data present in response, don't display
    if (this.designationEnabledOnPrimary && designationInResponse) {
      return false;
    }
    return true;
  }

  getFrequencyText(freq) {
    const orgCashFrequencies = this.settings.getValue('organization')
      .cash_frequencies;
    const freqs = {};
    orgCashFrequencies.forEach(element => {
      freqs[element.value] = element.text;
    });
    return freqs[freq];
  }

  private newWindowHandler(text) {
    if (text) {
      try {
        let newWindow = window.open(text, '', 'height=500,width=500');
        if (newWindow && window.focus) {
          newWindow.focus();
        }
        newWindow.onbeforeunload = () => (newWindow = null);
      } catch (error) {
        if (window && window.open) {
          window.open(text, '');
        } else {
          console.log(error);
        }
      }
    }
  }
  openPopUp() {
    this.newWindowHandler(this.share.facebook);
  }
  loadTwitter() {
    this.newWindowHandler(this.share.twitter);
  }
  removeTime(time: any, freq: string) {
    let dateArr: any, newDate: any;
    if (freq === 'twicemonthly') {
      dateArr = time.substr(0, 10).split('-');
      newDate = new Date();
      newDate.setHours(0, 0, 0, 0);
      newDate.setFullYear(parseInt(dateArr[0]));
      newDate.setMonth(parseInt(dateArr[1]) - 1, parseInt(dateArr[2]));
      return newDate;
    } else {
      return time;
    }
  }
  saveDesignation(close) {
    GaClient.trackButtonClick('Thank You-Designation');
    this.designations$.subscribe(item => {
      this.designationLoading = true;
      if (
        item.items.length > 0 &&
        (!this.requireCustomDesignation() || !!item.custom)
      ) {
        if (this.transaction.schedule && this.transaction.schedule.id) {
          this.donateAPI
            .updateDesignation('schedule', this.transaction.schedule.id, {
              designation_id: item.items[0].id,
              designation_note: item.custom
            })
            .subscribe(() => {
              close();
              this.designationDisplay = false;
            });
        } else {
          this.donateAPI
            .updateDesignation('transaction', this.transaction.id, {
              designation_id: item.items[0].id,
              designation_note: item.custom
            })
            .subscribe(() => {
              close();
              this.designationDisplay = false;
            });
        }
      } else {
        console.log('invalid');
      }
    });
  }
  saveCorporateMatching(close) {
    GaClient.trackButtonClick('Thank You-Corporate Match');

    const { billingInfo, tributeInfo, recurring, donation, corporateMatching } = this.resolvedState;
    const { doublethedonation } = window as any;
    if (doublethedonation) {
      try {
        doublethedonation.integrations.core.register_donation({
          '360matchpro_public_key': this.dtdPublicKey,
          partner_identifier: this.dtdPartnerKey,
          campaign: this.campaignId,
          donation_identifier: this.transaction.id,
          donation_amount: donation.amount,
          donor_first_name: billingInfo.firstName,
          donor_last_name: billingInfo.lastName,
          donor_email: billingInfo.email,
          donor_address: {
            zip: billingInfo.zip,
            city: billingInfo.city,
            state: billingInfo.state,
            address1: billingInfo.address1,
            address2: billingInfo.address2,
            country: billingInfo.country
          },
          donor_phone: billingInfo.phone,
          donation_datetime: new Date().toISOString(),
          in_memoriam: tributeInfo.completed.toString(),
          recurring: (recurring.frequency !== Frequency.Once).toString(),
          doublethedonation_company_id: corporateMatching.selected,
        });
      } catch (err) {
        console.error(err);
      }
    }

    this.corporateDisplay = false;
    close();
  }
  viewDonations() {
    let portal = this.settings.getValue('donor_portal_url');
    const slug = this.settings.getValue('organization')['slug'];
    const isBranded =
      this.settings
        .getValue('organization')
        ['features'].indexOf('branded_dss') >= 0;

    if (isBranded) {
      portal += `/${slug}`;
    }
    window.open(
      `${location.protocol}//${portal}/login#session_key=${this.sessionKey}`,
      '_blank'
    );
  }
  register() {
    this.modalService.open(RegisterModalComponent).result.then(
      (result: any) => {},
      error => {}
    );
  }

  getTwitterVal() {
    // https://developer.twitter.com/en/docs/twitter-for-websites/tweet-button/guides/web-intent
    const org = this.settings.getValue('organization');
    const hostedUrl = this.settings.getValue('properties').hosted_url;
    const propertySocial = this.settings.getValue('properties').social_sharing;
    const orgOverrides = org.attributes.widget.completion_overrides;
    const twitterBaseUrl = 'https://twitter.com/intent/tweet?';

    let twitterMessage = `I just made a difference for ${org.name}, see how you can get involved and join me.`;
    if (propertySocial && propertySocial.twitter_content) {
      twitterMessage = propertySocial.twitter_content;
    } else if (orgOverrides && orgOverrides.twitter_content) {
      twitterMessage = orgOverrides.twitter_content;
    }
    return `${twitterBaseUrl}text=${encodeURIComponent(
      twitterMessage
    )}&url=${encodeURIComponent(hostedUrl)}`;
  }

  getFacebookVal() {
    // sidenote: ngrok and facebook don't get along when testing these out, I've had good success with serveo.net
    // https://developers.facebook.com/docs/sharing/web
    // https://developers.facebook.com/docs/sharing/best-practices
    const org = this.settings.getValue('organization');
    const hostedUrl = this.settings.getValue('properties').hosted_url;
    const propertySocial = this.settings.getValue('properties').social_sharing;
    const orgOverrides = org.attributes.widget.completion_overrides;
    const facebookUrlBase =
      'https://www.facebook.com/dialog/share?app_id=718718328181364&display=popup';
    const facebookUrlEnd = `&href=${encodeURIComponent(hostedUrl)}`;
    let facebookMessage = `I just made a difference for ${org.name}, see how you can get involved and join me.`;

    if (propertySocial && propertySocial.facebook_content) {
      facebookMessage = propertySocial.facebook_content;
    } else if (orgOverrides && orgOverrides.facebook_content) {
      facebookMessage = orgOverrides.facebook_content;
    }
    return `${facebookUrlBase}&quote=${encodeURIComponent(
      facebookMessage
    )}${facebookUrlEnd}`;
  }

  getEmailVal() {
    const org = this.settings.getValue('organization');
    const hostedUrl = this.settings.getValue('properties').hosted_url;
    const propertySocial = this.settings.getValue('properties').social_sharing;
    const orgOverrides = org.attributes.widget.completion_overrides;
    let emailSubject = 'Help Impact a Life';
    let emailBody = `I just made a difference for ${org.name}, see how you can get involved and join me.\n\nVisit ${hostedUrl} to find out more!`;

    if (propertySocial && propertySocial.email_content) {
      emailBody = propertySocial.email_content;
    } else if (orgOverrides && orgOverrides.email_content) {
      emailBody = orgOverrides.email_content;
    }

    if (propertySocial && propertySocial.email_subject) {
      emailSubject = propertySocial.email_subject;
    } else if (orgOverrides && orgOverrides.email_subject) {
      emailSubject = orgOverrides.email_subject;
    }
    return `mailto:?subject=${encodeURIComponent(
      emailSubject
    )}&body=${encodeURIComponent(emailBody)}`;
  }

  openModal(content) {
    this.modalService.open(content).result.then(
      (result: any) => {},
      error => {}
    );
  }
}
